import { createPortal } from "react-dom"
import classNames from "classnames"
import styled from "styled-components"

import { ReactComponent as IconMissing } from "assets/svg/modal-icon-missing.svg"

import { ModalLayout } from "layouts/ModalLayout"

import styles from "./index.module.scss"

const StyledModalLayout = styled(ModalLayout)`
  z-index: 6003;

  & + .modalViewPort {
    z-index: 6002;
  }
`

const Content = styled.div`
  h3 {
    font-weight: 400;
  }

  span {
    color: #64748b;
    display: block;
    font-size: 14px;
    font-weight: 300;

    &:last-child {
      margin-top: 15px;
    }
  }
`

interface Props {
  onConfirm: () => void
  onCancel: () => void
}

export const DisableContractorUserModal = ({ onConfirm, onCancel }: Props) => {
  return (
    <>
      {createPortal(
        <StyledModalLayout width="420px" onConfirm={onConfirm} onCancel={onCancel}>
          <div className={classNames(styles.modalContent, styles.center)}>
            <IconMissing />
            <Content>
              <h3 className={styles.modalTitle}>Disable User</h3>
              <span>Are you sure you want to disable this user?</span>
              <span>They will no longer be able to log in or access the system.</span>
            </Content>
          </div>
        </StyledModalLayout>,
        document.body,
      )}
    </>
  )
}
